<nav class="sidebar card mb-4">

    <div class="top-menu bg-th-yellow d-flex justify-content-end w-100 align-items-center">

        <div class="d-flex w-100 col-12 justify-content-between dirI align-items-center">

            <p class="text-start fw-bold mt-2 me-3 text-dark f16 vazir"> {{ fullName }} </p>

            <i class="fa fa-close text-danger fa-2x me-3 pointer" (click)="close()"></i>

        </div>

    </div>
    
    <span class="text-center bg-th-yellow f14 text-dark pb-2 mb-1">

        {{ comapnyName }}

    </span>


    <ul class="nav flex-column dirI">

        <!-- سفر های اداری -->

        <li class="nav-item">

            <a class="nav-link pointer hoverMenu"> سفر های اداری <b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu">

                    <a class="w-100  pointer" target="_blank" href="/trip/automation/office-travel">

                        <i class="fa fa-plane text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> ثبت سفر </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-plane text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold">سفر درون سازمانی </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-plane text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> برنامه ریزی سفرهای پرسنل </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <a target="_blank" href="/trip/automation/staff-travel">

                        <i class="fa fa-plane text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> سفر های پرسنل من  </span>

                    </a>

                </li>
                
                <li class="pointer p-1 hoverMenu">

                    <a target="_blank" href="/trip/automation/manage-travel">

                        <i class="fa fa-plane text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> مدیریت سفرها  </span>

                    </a>

                </li>

            </ul>
            
        </li>

        <!-- جستجو و داشبورد -->

        <li class="nav-item">

            <a class="nav-link pointer hoverMenu">جستجو و داشبورد<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <!-- جستجوی سفرهای اداری -->

                <li class="pointer p-1 hoverMenu" >

                    <a class="w-100  pointer" target="_blank">

                        <i class="fa fa-area-chart text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> جستجوی سفرهای اداری </span>

                    </a>

                </li>

                <!-- داشبورد سفرهای اداری -->

                <li class="pointer p-1 hoverMenu" >

                    <!-- <a class="w-100  pointer" target="_blank" [routerLink]="['/reportage/officeTravel-Dashboard']"> -->

                    <a class="w-100  pointer" target="_blank" [routerLink]="['/trip/dashboard/office-travel']">

                        <i class="fa fa-area-chart text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> داشبورد سفرهای اداری </span>

                    </a>

                </li>

                <!-- نمودار کیفی رانندگان -->

                <li class="pointer p-1 hoverMenu" >

                    <a class="w-100  pointer" target="_blank">

                        <i class="fa fa-area-chart text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> نمودار کیفی رانندگان </span>

                    </a>

                </li>
                
                <!-- وضعیت سفرهای امروز -->

                <li class="pointer p-1 hoverMenu" >

                    <a class="w-100  pointer" target="_blank">

                        <i class="fa fa-area-chart text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> وضعیت سفرهای امروز </span>

                    </a>

                </li>

            </ul>

        </li>

        <!-- گزارش های عملکردی -->

        <li class="nav-item">

            <a class="nav-link pointer hoverMenu">گزارش های عملکردی<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu" [routerLink]="['/reportage/driver-Function']">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> کارکرد رانندگان به تفکیک تاریخ </span>

                </li>

                <li class="pointer p-1 hoverMenu" [routerLink]="['/reportage/TripBaseChart']">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> تعداد سفر به تفکیک جایگاه </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> حضور و غیاب رانندگان </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> گزارش زمانی سفرها </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> کارکرد رانندگان به تفکیک تاریخ </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> سرجمع کارکرد رانندگان  </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> گزارش کیفی رانندگان  </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> گزارش سفر به تفکیک جایگاه </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> کارکرد رانندگان به تفکیک تاریخ </span>

                </li>

            </ul>

        </li>

        <!-- گزارش های مالی -->

        <li class="nav-item">

            <a class="nav-link pointer hoverMenu">گزارش های مالی<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu">

                    <a class="w-100  pointer" target="_blank" href="/reportage/financial-reports">

                        <i class="fa fa-list text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> بررسی و تایید کارکرد رانندگان </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <a class="w-100  pointer" target="_blank">

                        <i class="fa fa-list text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> بررسی و تایید کارکرد رانندگان </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> کسورات قانونی و فیش حقوق </span>

                </li>

            </ul>

        </li>

        <!-- مدیریت کاربران -->

        <li class="nav-item">

            <a class="nav-link pointer hoverMenu">مدیریت کاربران<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> چارت سازمانی </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> دسترسی چارت سازمانی </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> ثبت و ویرایش پرسنل </span>

                </li>

            </ul>

        </li>

        <!-- اطلاعات پایه -->

        <li class="nav-item">

            <a class="nav-link pointer hoverMenu">اطلاعات پایه<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu" [routerLink]="['/tripAutomation']">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold">خودرو و خدمات</span>

                </li>

                <li class="pointer p-1 hoverMenu" [routerLink]="['/tripAutomation/serviceArea']">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold">حوزه خدمت</span>

                </li>

                <li class="pointer p-1 hoverMenu" (click)="holidayModal()">

                    <i class="fa fa-calendar text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold">ثبت و ویرایش تعطیلات</span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> تعرفه خدمات </span>

                </li>

                <li class="pointer p-1 hoverMenu">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold"> ثبت راننده </span>

                </li>

            </ul>

        </li>

    </ul>

    <div class="d-flex logout-btn justify-content-center text-dark p-2 mt-4 bg-th-yellow pointer"

        (click)="clickMethod('name')">

        <span class="f14"><i class="fa fa-power-off fa-lg text-danger"></i>&nbsp; خروج از حساب کاربری</span>

    </div>

</nav>